(ns lupapalvelu.ui.docgen.field.docgen-checkbox
  (:require [lupapalvelu.next.event :refer [<sub]]
            [lupapalvelu.ui.common :as common]
            [lupapalvelu.ui.components.input :as ui-input]
            [lupapalvelu.ui.docgen.component.ping :as ping]
            [lupapalvelu.ui.docgen.feature.emit :as emit]
            [lupapalvelu.ui.docgen.feature.validation :as validation]
            [lupapalvelu.ui.docgen.feature.value :as value]
            [lupapalvelu.ui.docgen.field.common :as docgen-common]
            [lupapalvelu.ui.docgen.field.docgen-input-common :as di]
            [lupapalvelu.ui.docgen.path :as path]
            [lupapalvelu.ui.docgen.schemas :as schemas]
            [lupapalvelu.ui.misc]
            [sade.util :as util]
            [schema.core :as sc]))

(sc/defn render
  "See `docgen-checkbox-template.html`"
  [{:keys [app-id doc-id schema path disabled?] :as args} :- schemas/DocgenFieldArguments]
  (let [validation-result-level    (<sub [::validation/field-data-validation-result-level doc-id path])
        read-only?                 (docgen-common/is-read-only? (util/mmap doc-id path schema))
        can-modify?                (and (not disabled?) (not read-only?))
        input-id                   (path/path->id path doc-id)
        {:keys [label aria-label]} (di/args->label args)
        value                      (<sub [::value/current-field-value doc-id path])
        input-classes              (di/input-classes schema :checkbox validation-result-level)]
    [(di/container schema) {:class "form-entry"}
     [di/docgen-label {:id                      input-id
                       :label                   label
                       :size                    (:size schema)
                       :validation-result-level validation-result-level
                       :class                   input-classes}]
     [ui-input/checkbox
      (cond-> {:id        input-id
               :checked?  value
               :disabled? (not can-modify?)
               :class     "input-classes"}
        can-modify? (assoc :on-change (docgen-common/make-on-change-immediate
                                        (util/mmap {:emit-data (emit/schema->emit-data (util/mmap app-id doc-id schema))}
                                                   app-id doc-id path)))
        aria-label (assoc :aria-label (common/loc aria-label)))]
     [ping/ping {:doc-id doc-id :field-path path :mode :icon}]]))
